import { Button, Heading, Paragraph, Popup } from '@quickmd-llc/design-system'

type Props = {
  isOpen: boolean
  onDefer: () => void
  onContinue: () => void
  timeoutMinutes: number
}

export const AreYouStillThereModal: React.FC<Props> = ({ isOpen, onDefer, onContinue, timeoutMinutes }: Props) => (
  <Popup
    onClose={onContinue}
    isOpen={isOpen}
    showCloseIcon
    styles={{ containerClassName: 'w-[512px]' }}
    header={{ content: <Heading level='h3'>Are you still there?</Heading> }}
    body={
      <div className='w-full max-w-md rounded-lg bg-white'>
        <Paragraph className='text-text-medium'>
          This visit must be completed within {timeoutMinutes} minutes of starting. Please defer or complete the visit.
        </Paragraph>
      </div>
    }
    footer={
      <div className='flex justify-end gap-sp-1'>
        <Button priority='secondary' onClick={onDefer}>
          Defer
        </Button>
        <Button priority='primary' onClick={onContinue}>
          Continue visit
        </Button>
      </div>
    }
  />
)
